import { fromJS } from 'immutable';
import { fetchSequenceStepSummary as fetchSequenceStepSummaryLib } from 'sequences-lib/api/SequencesV2Api';
import { fetchPastEnrollment } from 'sequences-lib/api/SequencesV1Api';
export function fetchSequenceStepSummary(sequenceStepEnrollmentId) {
  return fetchSequenceStepSummaryLib(sequenceStepEnrollmentId).then(fromJS);
}
export function fetchSequenceEnrollment(sequenceEnrollmentId) {
  return fetchPastEnrollment(sequenceEnrollmentId).then(fromJS);
}